import { useNavigation } from '@react-navigation/native';
import { SPACING } from 'base/src/ui/CommonStyles';
import { PageContainer } from 'base/src/ui/components/PageContainer';
import { useTranslate } from 'base/src/ui/locale/locale';
import { PrivilegeUrl } from 'ehawker/src/data/schemas/user/PrivilegeSchema';
import { useActiveHawkerUser } from 'ehawker/src/ui/hooks/useActiveHawkerUser';
import { useHawkerUser } from 'ehawker/src/ui/hooks/useHawkerUser';
import { useLastOrder } from 'ehawker/src/ui/query/useLastOrder';
import { usePrivilege } from 'ehawker/src/ui/query/usePrivilege';
import { useEffect } from 'react';
import { ScrollView } from 'react-native';
import { FAB } from 'react-native-paper';

import { CurrentMonthSection } from './CurrentMonthSection';
import { MonthlyUsageSection } from './chart/MonthlyUsageSection';
import { PendingDeliverySection } from './pending/PendingDeliverySection';
import { useDashboardTitle } from '../../hooks/useDashboardTitle';
import { NavigationProps, RouteNames } from '../../navigation/Routes';

export function Dashboard() {
  const navigation = useNavigation<NavigationProps>();
  const { privilegeLoading, checkPrivilege } = usePrivilege();
  const user = useHawkerUser();
  // prefetch
  useLastOrder(user?._stsn);
  useActiveHawkerUser();
  const { t } = useTranslate();
  useDashboardTitle(t('dashboard'));

  useEffect(() => {
    const getParamsFromHash = (hash: string) => {
      return hash
        .substring(1)
        .split('&')
        .reduce((params: any, keyValue) => {
          const [key, value] = keyValue.split('=');
          params[key] = value;
          return params;
        }, {});
    };
    const params = getParamsFromHash(window.location.hash);
    if (params.p && params.stcode) {
      navigation.navigate(params.p, { stcode: params.stcode });
    }
  }, [navigation]);

  if (privilegeLoading) {
    return (
      <PageContainer>
        <></>
      </PageContainer>
    );
  }
  return (
    <PageContainer>
      <ScrollView
        style={{
          margin: -SPACING.s,
          padding: SPACING.s,
        }}
      >
        <PendingDeliverySection />
        <CurrentMonthSection />
        <MonthlyUsageSection />
      </ScrollView>
      {checkPrivilege(PrivilegeUrl.NewOrder) && (
        <FAB
          onPress={() => navigation.navigate(RouteNames.NewOrder, {})}
          label={t('order')}
          style={{
            position: 'absolute',
            margin: SPACING.l,
            right: 0,
            bottom: 0,
          }}
        />
      )}
    </PageContainer>
  );
}
